<template>
  <section
    :style="{
      height: '100vh',
    }"
  >
    <div class="grid grid-nogutter h-full md:flex-row bg-white">
      <div class="col-12 md:col-5">
        <div
          class="pod-image"
          :style="{
            backgroundImage: `url(${rectLogo})`,
          }"
        >
        </div>
      </div>
      <div class="col-12 md:col-7 bg-white">
        <div class="flex justify-content-center md:pt-8 px-3">
          <div class="password-reset-form-container">
            <VeeForm
              v-slot="{ handleSubmit }"
              :validation-schema="schema"
              as="div"
              @invalidSubmit="onInvalidSubmit"
            >
              <form @submit.prevent="handleSubmit($event, onSubmit)">
                <h1 class="text-center text-4xl">Password Reset</h1>

                <BasePassword
                  v-model="form.password"
                  fieldId="password"
                  fieldName="password"
                  fieldLabel="Password"
                  class="w-full"
                  inputClass="w-full"
                />
                <BasePassword
                  v-model="form.confirmPassword"
                  fieldId="confirmPassword"
                  fieldName="confirmPassword"
                  fieldLabel="Confirm Password"
                  class="w-full"
                  inputClass="w-full"
                  :feedback="false"
                />

                <Button
                  class="justify-content-center w-full"
                  type="submit"
                  :loading="isSubmitting"
                  label="Submit"
                />
              </form>
            </VeeForm>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import { object, ref, string } from 'yup';
import rectLogo from '@/assets/ekoz_rect.jpeg';
import { parseMessageFromError } from '@/utils/errors';
import { INVALID_FORM_SUBMISSION_MESSAGE } from '@/utils/messages';
import { ROUTE_LOGIN } from '@/router/routes';
import * as api from '@/api';

export default {
  data() {
    return {
      rectLogo,
      isSubmitting: false,
      form: {
        password: '',
        confirmPassword: '',
      },
      schema: object({
        password: string().required('Password is required'),
        confirmPassword: string().required('Confirm Passoword is required')
          .oneOf([ref('password'), ''], 'Passwords must match'),
      }),
    };
  },
  methods: {
    onInvalidSubmit() {
      this.$toast.add({
        severity: 'warn',
        detail: INVALID_FORM_SUBMISSION_MESSAGE,
      });
    },
    async onSubmit({ password }) {
      try {
        this.isSubmitting = true;

        const { token } = this.$route.query;

        if (!token) {
          this.$toast.add({
            severity: 'error',
            detail: 'Token is missing from url. Try a new password reset.',
          });
        }

        await api.resetPassword({
          token,
          password,
        });

        this.$toast.add({
          severity: 'success',
          detail: 'Successfully reset password. Navigating to login page',
        });
        this.$router.push({
          name: ROUTE_LOGIN,
        });
      } catch (error) {
        const message = parseMessageFromError(error, 'Invalid email or password');

        this.$toast.add({
          severity: 'error',
          detail: message,
        });
      } finally {
        this.isSubmitting = false;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.password-reset-form-container {
  display: flex;
  flex-direction: column;
  flex-grow: 1;
  max-width: 400px;
}
.pod-image {
  height: 140px;
  width: 100%;
  background-size: cover;
  background-position: center 25%;

  @media (min-width: 768px) {
    height: 100%;
    background-position: center;
  }
}
</style>
